import React, { FunctionComponent } from "react";
import { ReduxStateModalPallets2 } from "../../../types/redux/reduxStateModalPallets2";
import { IAplSettings } from "../../../redux/helpers/aplSettingsHelper";
import { translateString } from "../../../translations/gridTranslationHelper";
import ModalDefects2PalletsDisplay from "./ModalDefects2PalletsDisplay";
import ModalDefects2DefectsTable from "./ModalDefects2DefectsTable";
import ModalDefects2TypeSelection from "./ModalDefects2TypeSelection";
import ModalDefects2CommentSection from "./ModalDefects2CommentSection";
import ModalDefects2BlockedStatusWarning from "./ModalDefects2BlockedStatusWarning";

interface ModalBodyProps {
    modalPallets2Redux: ReduxStateModalPallets2;
    aplSettings: IAplSettings;
    defectAdd: string;
    defectRemove: string;
    defectTypes: any[];
    handleChange: (e: React.ChangeEvent<HTMLInputElement>, dataKey: string) => void;
    addDefect: () => void;
    removeDefect: (id: string) => void;
    hideBlockPackaging: boolean;
    hideBlockQI: boolean;
    showCommentBox: boolean;
    updateCommentBlank: boolean;
    palletsHaveSameStatus: (pallets: any[], statusId: number) => boolean;
}

const ModalDefects2Body: FunctionComponent<ModalBodyProps> = ({
    modalPallets2Redux,
    aplSettings,
    defectAdd,
    defectRemove,
    defectTypes,
    handleChange,
    addDefect,
    removeDefect,
    hideBlockPackaging,
    hideBlockQI,
    showCommentBox,
    updateCommentBlank,
    palletsHaveSameStatus
}) => (
    <div className="modal-body">
        <div className="overflow-auto" style={{ minHeight: "20rem", maxHeight: "40rem" }} id="modal-overflow">
            {modalPallets2Redux.message && (
                <div className="alert alert-danger" role="alert">
                    {modalPallets2Redux.message}
                </div>
            )}
            <ModalDefects2BlockedStatusWarning
                isUsSite={aplSettings.isUsSite}
                siteId={aplSettings.siteId}
                pallets={modalPallets2Redux.pallets}
            />
            <ModalDefects2BodyForm
                modalPallets2Redux={modalPallets2Redux}
                aplSettings={aplSettings}
                defectAdd={defectAdd}
                defectRemove={defectRemove}
                defectTypes={defectTypes}
                handleChange={handleChange}
                addDefect={addDefect}
                removeDefect={removeDefect}
                hideBlockPackaging={hideBlockPackaging}
                hideBlockQI={hideBlockQI}
                showCommentBox={showCommentBox}
                updateCommentBlank={updateCommentBlank}
                palletsHaveSameStatus={palletsHaveSameStatus}
            />
        </div>
    </div>
);

const ModalDefects2BodyForm: FunctionComponent<ModalBodyProps> = props => {
    const { modalPallets2Redux, handleChange, ...rest } = props;

    return (
        <form className="m-2">
            <ModalDefects2PalletsDisplay pallets={modalPallets2Redux.pallets} siteId={rest.aplSettings.siteId} />
            <ModalDefects2DefectsTable
                pallets={modalPallets2Redux.pallets}
                defectAddImg={rest.defectAdd}
                defectRemoveImg={rest.defectRemove}
                defectTypes={rest.defectTypes}
                handleChange={handleChange as any}
                addDefect={rest.addDefect}
                removeDefect={rest.removeDefect}
                culture={rest.aplSettings.culture}
            />
            <ModalDefects2TypeSelection
                pallets={modalPallets2Redux.pallets}
                handleChange={handleChange}
                hideBlockPackaging={rest.hideBlockPackaging}
                hideBlockQI={rest.hideBlockQI}
                aplSettings={rest.aplSettings}
                palletsHaveSameStatus={rest.palletsHaveSameStatus}
                translateString={translateString}
            />
            {modalPallets2Redux.modified && rest.showCommentBox && (
                <ModalDefects2CommentSection
                    handleChange={handleChange}
                    updateCommentBlank={rest.updateCommentBlank}
                    comment={modalPallets2Redux.pallets[0]?.palletUpdateComment ?? ""}
                    showCommentBox={rest.showCommentBox}
                />
            )}
        </form>
    );
};

export default ModalDefects2Body;
